'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// import VoucherCard from 'components/Box/VoucherCard';
// import { Row, Col } from 'react-bootstrap';

// import moment from 'moment';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var _support = require('helpers/support');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingPlans = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(PricingPlans, _Component);

    function PricingPlans(props) {
        (0, _classCallCheck3.default)(this, PricingPlans);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PricingPlans.__proto__ || (0, _getPrototypeOf2.default)(PricingPlans)).call(this, props));

        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(PricingPlans, [{
        key: 'render',
        value: function render() {
            var costBasic = 240000;
            var costStandard = 270000;
            var costPremium = 450000;
            var promotion12 = 0.85; // giảm 15 %
            var promotion24 = 0.75; // giảm 25%
            var styles = require('./PricingPlansMobile.scss');
            return _react2.default.createElement(
                'div',
                { className: styles.container + ' container' },
                _react2.default.createElement(_components.HelmetSEO, { path: 'uu-dai' }),
                _react2.default.createElement(
                    'div',
                    { className: styles.intro },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'T\u0102NG KH\xC1CH H\xC0NG M\u1EDAI & QU\u1EA2N L\xDD D\u1EC4 D\xC0NG CHO SPA/SALON'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: styles.pricingView + ' ' + styles.basicView },
                    _react2.default.createElement(
                        'article',
                        { className: styles.plan },
                        _react2.default.createElement(
                            'section',
                            { className: styles.BGBasic },
                            _react2.default.createElement(
                                'h3',
                                null,
                                'Basic'
                            ),
                            _react2.default.createElement('hr', null),
                            _react2.default.createElement(
                                'p',
                                { className: styles.price },
                                _support.Helper.formatMoney(costBasic)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                _components.Collapse,
                                {
                                    label: 'Ph\u1EA7n m\u1EC1m qu\u1EA3n l\xFD',
                                    iconDown: true,
                                    headStyle: styles.headStyle
                                },
                                _react2.default.createElement(
                                    'ul',
                                    { className: styles.collapseContent },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Qu\u1EA3n l\xFD salon (ERP) Desktop'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Qu\u1EA3n l\xFD salon (ERP) Mobile'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                _components.Collapse,
                                {
                                    label: 'Ch\u0103m s\xF3c kh\xE1ch h\xE0ng',
                                    iconDown: true,
                                    headStyle: styles.headStyle
                                },
                                _react2.default.createElement(
                                    'ul',
                                    { className: styles.collapseContent },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Chat t\u01B0 v\u1EA5n kh\xE1ch h\xE0ng'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                _components.Collapse,
                                {
                                    label: 'Gi\u1EA3i ph\xE1p marketing ti\u1EBFp c\u1EADn KH m\u1EDBi',
                                    iconDown: true,
                                    headStyle: styles.headStyle
                                },
                                _react2.default.createElement(
                                    'ul',
                                    { className: styles.collapseContent },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Shop ri\xEAng tr\xEAn Lookme.vn k\xEDch ho\u1EA1t \u0111\u1EB7t l\u1ECBch'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                'ul',
                                { className: styles.collapseContent },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng chi nh\xE1nh'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        '1 (*)'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng t\xE0i kho\u1EA3n qu\u1EA3n l\xFD'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        '5'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng nh\xE2n vi\xEAn'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        '10'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng s\u1EA3n ph\u1EA9m/d\u1ECBch v\u1EE5'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        '500'
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: styles.pricingView + ' ' + styles.standardView },
                    _react2.default.createElement(
                        'article',
                        { className: styles.plan },
                        _react2.default.createElement(
                            'section',
                            { className: styles.BGStandard },
                            _react2.default.createElement(
                                'h3',
                                null,
                                'Plus'
                            ),
                            _react2.default.createElement('hr', null),
                            _react2.default.createElement(
                                'p',
                                { className: styles.price },
                                _support.Helper.formatMoney(costStandard)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                _components.Collapse,
                                {
                                    label: 'Ph\u1EA7n m\u1EC1m qu\u1EA3n l\xFD',
                                    iconDown: true,
                                    headStyle: styles.headStyle
                                },
                                _react2.default.createElement(
                                    'ul',
                                    { className: styles.collapseContent },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Qu\u1EA3n l\xFD salon (ERP) Desktop'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Qu\u1EA3n l\xFD salon (ERP) Mobile'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                _components.Collapse,
                                {
                                    label: 'Ch\u0103m s\xF3c kh\xE1ch h\xE0ng',
                                    iconDown: true,
                                    headStyle: styles.headStyle
                                },
                                _react2.default.createElement(
                                    'ul',
                                    { className: styles.collapseContent },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Chat t\u01B0 v\u1EA5n kh\xE1ch h\xE0ng'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                _components.Collapse,
                                {
                                    label: 'Gi\u1EA3i ph\xE1p marketing ti\u1EBFp c\u1EADn KH m\u1EDBi',
                                    iconDown: true,
                                    headStyle: styles.headStyle
                                },
                                _react2.default.createElement(
                                    'ul',
                                    { className: styles.collapseContent },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Ti\u1EBFp c\u1EADn kh\xE1ch h\xE0ng m\u1EDBi qua s\xE0n Lookme.vn'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Shop ri\xEAng tr\xEAn Lookme.vn k\xEDch ho\u1EA1t \u0111\u1EB7t l\u1ECBch'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                'ul',
                                { className: styles.collapseContent },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng chi nh\xE1nh'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        '2 (*)'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng t\xE0i kho\u1EA3n qu\u1EA3n l\xFD'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        '10'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng nh\xE2n vi\xEAn'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        '20'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng s\u1EA3n ph\u1EA9m/d\u1ECBch v\u1EE5'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        'Kh\xF4ng gi\u1EDBi h\u1EA1n'
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: styles.pricingView + ' ' + styles.premiumView },
                    _react2.default.createElement(
                        'article',
                        { className: styles.plan },
                        _react2.default.createElement(
                            'section',
                            { className: styles.BGPremium },
                            _react2.default.createElement(
                                'h3',
                                null,
                                'Premium'
                            ),
                            _react2.default.createElement('hr', null),
                            _react2.default.createElement(
                                'p',
                                { className: styles.price },
                                _support.Helper.formatMoney(costPremium)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                _components.Collapse,
                                {
                                    label: 'Ph\u1EA7n m\u1EC1m qu\u1EA3n l\xFD',
                                    iconDown: true,
                                    headStyle: styles.headStyle
                                },
                                _react2.default.createElement(
                                    'ul',
                                    { className: styles.collapseContent },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Qu\u1EA3n l\xFD salon (ERP) Desktop'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Qu\u1EA3n l\xFD salon (ERP) Mobile'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                _components.Collapse,
                                {
                                    label: 'Ch\u0103m s\xF3c kh\xE1ch h\xE0ng',
                                    iconDown: true,
                                    headStyle: styles.headStyle
                                },
                                _react2.default.createElement(
                                    'ul',
                                    { className: styles.collapseContent },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Chat v\u1EDBi kh\xE1ch h\xE0ng'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'T\u1ED5ng \u0111\xE0i ch\u0103m s\xF3c'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                _components.Collapse,
                                {
                                    label: 'Gi\u1EA3i ph\xE1p marketing ti\u1EBFp c\u1EADn KH m\u1EDBi',
                                    iconDown: true,
                                    headStyle: styles.headStyle
                                },
                                _react2.default.createElement(
                                    'ul',
                                    { className: styles.collapseContent },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Ti\u1EBFp c\u1EADn kh\xE1ch h\xE0ng m\u1EDBi qua s\xE0n Lookme.vn'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Shop ri\xEAng tr\xEAn Lookme.vn k\xEDch ho\u1EA1t \u0111\u1EB7t l\u1ECBch'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Banner qu\u1EA3ng c\xE1o tr\xEAn Lookme.vn'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'B\xE0i review tr\xEAn Facebook Lookme'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: styles.rowView },
                            _react2.default.createElement(
                                'ul',
                                { className: styles.collapseContent },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng chi nh\xE1nh'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        '4 (*)'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng t\xE0i kho\u1EA3n qu\u1EA3n l\xFD'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        'Kh\xF4ng gi\u1EDBi h\u1EA1n'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng nh\xE2n vi\xEAn'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        'Kh\xF4ng gi\u1EDBi h\u1EA1n'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        'S\u1ED1 l\u01B0\u1EE3ng s\u1EA3n ph\u1EA9m/d\u1ECBch v\u1EE5'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        'Kh\xF4ng gi\u1EDBi h\u1EA1n'
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { style: { marginTop: "20px" } },
                    _react2.default.createElement(
                        'div',
                        { className: styles.note },
                        '* Ph\xED hoa h\xF4ng tr\xEAn 1 kh\xE1ch h\xE0ng m\u1EDBi l\xE0 35%.'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: styles.note },
                        '(*) M\u1ED7i chi nh\xE1nh t\u0103ng th\xEAm 200k. Salon tr\xEAn 5 chi nh\xE1nh, vui l\xF2ng li\xEAn h\u1EC7 Lookme.'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: styles.note },
                        '* Gi\xE1 tr\xEAn ch\u1EC9 \xE1p d\u1EE5ng cho g\xF3i mua 6 th\xE1ng.'
                    )
                ),
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/dang-ki-doi-tac', className: styles.btnRegisterPartner },
                    '\u0110\u0102NG K\xDD'
                )
            );
        }
    }]);
    return PricingPlans;
}(_react.Component), _class.propTypes = {}, _temp);
exports.default = PricingPlans;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/PricingPlans/index.js
// module id = 1623
// module chunks = 0